import { useMemo } from 'react'

import {
    showIntercom,
    showIntercomNewMessage as showIntercomNewMessageAction,
    trackIntercomEvent,
    updateIntercomProfile as updateIntercomProfileAction,
} from '@/actions'
import { useAppDispatch } from '@/store'

export const useIntercomActions = () => {
    const dispatch = useAppDispatch()

    return useMemo(
        () => ({
            openIntercom: () => dispatch(showIntercom()),
            updateIntercomProfile: (data?: Record<string, unknown>) => dispatch(updateIntercomProfileAction(data)),
            showIntercomNewMessage: (message?: string) => dispatch(showIntercomNewMessageAction(message)),
            trackIntercomEvent: (...args: unknown[]) => dispatch(trackIntercomEvent(...args)),
        }),
        [dispatch]
    )
}
